document.addEventListener('DOMContentLoaded', function () {
    const step1 = document.getElementById('step1');
    const step2 = document.getElementById('step2');
    const step3 = document.getElementById('step3');
    const step4 = document.getElementById('step4');
    //const cnpjForm = document.getElementById('cnpjForm');
    const cnpjInput = document.getElementById('cnpj');
    const checkCNPJButton = document.getElementById('checkCNPJ');
    const formDiv = document.getElementById('form_data');
    const backToStep1Button = document.getElementById('backToStep1');
    const toStep3Button = document.getElementById('toStep3');
    const backToStep2Button = document.getElementById('backToStep2');
    const personalForm = document.getElementById('personalForm');
    const progressSteps = document.querySelectorAll('.progress-step');


    document.getElementById("cnpj").addEventListener("input", function (e) {
        let value = e.target.value.replace(/\D/g, ""); // só números

        // aplica a máscara
        if (value.length > 2) {
            value = value.replace(/^(\d{2})(\d)/, "$1.$2");
        }
        if (value.length > 5) {
            value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        }
        if (value.length > 8) {
            value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
        }
        if (value.length > 12) {
            value = value.replace(/(\d{4})(\d)/, "$1-$2");
        }

        e.target.value = value;
    });


    function updateProgress(step) {
        progressSteps.forEach((progressStep, index) => {
            if (index < step - 1) {
                progressStep.classList.add('completed');
                progressStep.classList.remove('active');
            } else if (index === step - 1) {
                progressStep.classList.add('active');
                progressStep.classList.remove('completed');
            } else {
                progressStep.classList.remove('completed', 'active');
            }
        });
    }

    checkCNPJButton.addEventListener('click', function () {
        let cnpjValid = validarCNPJ(cnpjInput.value);

        if (cnpjInput.value && cnpjValid) {
            const content_filiais = document.getElementById('content_filiais');
            content_filiais.classList.remove('active');

            const cnpjSanitized = cnpjInput.value.replace(/[^\d]/g, '');
            fetch(`https://api.cnpja.com.br/office/${cnpjSanitized}?strategy=CACHE_IF_ERROR&registrations=BR`, {
                method: 'GET',
                headers: {
                    authorization: '3d2c7406-8311-41cf-bbd3-f8f392ea8b4e-3a5f68ab-5e68-49f8-aff7-24519b5255f1',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data) {
                        if (data?.status?.text === 'Ativa') {
                            const state = (data?.address?.state || '').trim().toUpperCase();
                            const registrations = Array.isArray(data?.registrations) ? data.registrations : [];
                            let firstRegistrationWithNumber = null;

                            for (const registration of registrations) {
                                if ((registration?.number || '').trim() !== '') {
                                    firstRegistrationWithNumber = registration;
                                    break;
                                }
                            }

                            const hasIE = Boolean(firstRegistrationWithNumber);

                            if (state !== 'SP' && !hasIE) {
                                var messageDiv = document.getElementById('msg_error');
                                messageDiv.innerText = 'Para continuar, o CNPJ deve ter uma Inscrição Estadual válida.';
                                return
                            }

                            const ieNumber = hasIE ? firstRegistrationWithNumber.number : 'Isento';

                            formDiv.innerHTML = `
                            <div class="form_group">
                              <div>Inscrição Estadual<strong id='inscricaoEstadual'>${ieNumber}</strong></div>
                              <div>Razão Social <strong id='company'>${data.company.name}</strong></div>
                            </div>
                            <div class="form_group">
                              <div>CEP <strong id='zip'>${data.address.zip}</strong></div>
                              <div>Estado <strong id='state'>${data.address.state}</strong></div>
                            </div>
                            <div class="form_group">
                              <div>Endereço <strong id='street'>${data.address.street}</strong></div>
                              ${data.address.number == "S/N"
                                    ? "<div>Número<input type='text' id='number_input' value='' /></div>" : "<div>Número <strong id='number'>" + data.address.number + "</strong></div>"}                             
                            </div>
                            <div class="form_group">
                              <div>Bairro <strong id='bairro'>${data.address.district ? data.address.district : ''}</strong></div>
                              <div>Cidade <strong id='city'>${data.address.city}</strong></div>                              
                            </div>
                             <div class="form_group">                             
                              <div>Complemento <strong id='complemento'>${data.address.details ? data.address.details : ''}</strong></div>                              
                            </div>
                        `;

                            const url = new URL(window.location.href);
                            if (url.hash === '#empresa') {
                                const idFiliais = data.company.id;
                                fetch(`https://api.cnpja.com.br/company/${idFiliais}`, {
                                    method: 'GET',
                                    headers: {
                                        authorization: 'f22fdacf-7c77-41a1-8f3f-6c59b979c8a0-8cc826a7-c308-4654-8322-b23de3059043',
                                    },
                                })
                                    .then((response) => response.json())
                                    .then((data) => {
                                        const filiais = data.offices;
                                        const listFiliais = document.getElementById('list_filiais');
                                        listFiliais.innerHTML = '';

                                        if (filiais) {
                                            filiais?.forEach((filial) => {
                                                const filialDiv = document.createElement('div');
                                                filialDiv.innerHTML = `<div>CNPJ <b>${filial.taxId}</b></div>
                          <br><div>Fundada <b>${filial.founded}</b></div>
                          <br><div>Status <b>${filial.status?.text}</b></div>`;
                                                listFiliais.appendChild(filialDiv);
                                            });

                                            const content_filiais = document.getElementById('content_filiais');
                                            content_filiais.classList.add('active');
                                        }
                                    });
                            }

                            step1.classList.remove('form-step-active');
                            step2.classList.add('form-step-active');
                            updateProgress(2);
                            var messageDiv = document.getElementById('msg_error');
                            messageDiv.innerText = '';
                        } else {
                            var messageDiv = document.getElementById('msg_error');
                            messageDiv.innerText = 'CNPJ inativo.';
                        }
                    } else {
                        var messageDiv = document.getElementById('msg_error');
                        messageDiv.innerText = 'CNPJ não encontrado.';
                    }
                })
                .catch((error) => console.error('Erro:', error));
        } else {
            var messageDiv = document.getElementById('msg_error');
            messageDiv.innerText = 'Por favor, insira um CNPJ válido.';
        }
    });

    backToStep1Button.addEventListener('click', function () {
        step2.classList.remove('form-step-active');
        step1.classList.add('form-step-active');
        updateProgress(1);
    });

    toStep3Button.addEventListener('click', function () {
        var number_input = document.getElementById('number_input');

        if (number_input && number_input?.value === "") {
            return number_input.style.border = '1px solid red';
        }
        else if (number_input) {
            number_input.style.border = 'none';
        }
        step2.classList.remove('form-step-active');
        step3.classList.add('form-step-active');
        updateProgress(3);
    });

    backToStep2Button.addEventListener('click', function () {
        step3.classList.remove('form-step-active');
        step2.classList.add('form-step-active');
        updateProgress(2);
    });

    personalForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        step3.classList.remove('form-step-active');
        step4.classList.add('form-step-active');

        const firstName = document.getElementById('firstName').value;
        const remarketing = document.getElementById('remarketing').checked;

        const lastName = document.getElementById('lastName').value;
        const emailContact = document.getElementById('emailContact').value;
        const email = document.getElementById('email').value;
        const cargo = document.getElementById('cargo').value;
        const phone = document.getElementById('phone');
        const phoneContact = document.getElementById('phoneCel');
        const cnpjMatriz = document.getElementById('cnpj').value;

        const address1 = document.getElementById('street').innerText;
        const bairro = document.getElementById('bairro').innerText;
        const companyAd = document.getElementById('company').innerText;
        const numberField = document.getElementById('number')?.innerText;
        const numberInput = document.getElementById('number_input')?.value;
        const state = document.getElementById('state').innerText;
        const city = document.getElementById('city').innerText;
        const zip = document.getElementById('zip').innerText;
        const complemento = document.getElementById('complemento').innerText;
        const inscricaoEstadual = document.getElementById('inscricaoEstadual').innerText;

        const isExist = await verifyClient(email);
        const isLogged = document.getElementById('isLogged').innerText;
        const userId = document.getElementById("isLogged")?.dataset.userid;

        if (!isLogged && isExist) {
            console.log("Já existe :/");
            displayMessage('Email já cadastrado', "error");
            return;
        }
        console.log('phone', phone?.value?.length);

        if (phoneContact?.value?.length < 14) {
            displayMessage('Telefone celular obrigatório. O número deve conter no mínimo 10 dígitos, considerando o DDD.', "error");
            return;
        }

        const url = baseUrl + (isLogged ? `2025-07/graphql.json` : '2024-04/customers.json');
        const headers = {
            'Content-Type': 'application/json',
            'apiKey': apiPassword
        };
        if (isLogged) {
            const query = `
            mutation customerUpdate($input: CustomerInput!) {
                customerUpdate(input: $input) {
                customer {
                    id
                    firstName
                    lastName
                    email
                    phone
                    metafields(first: 10) {
                    edges {
                        node {
                        namespace
                        key
                        value
                        }
                    }
                    }
                }
                userErrors {
                    field
                    message
                }
                }
            }
            `;

            const variables = {
                input: {
                    id: `gid://shopify/Customer/${userId}`, // ID obrigatório no formato GID
                    firstName,
                    lastName,
                    email,
                    phone: formatPhoneSend(phoneContact),
                    addresses: [
                        {
                            address1: `${address1}, ${numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField}`,
                            address2: complemento ? `${complemento}, ${bairro}` : bairro,
                            city,
                            province: state,
                            phone: formatPhoneSend(phoneContact),
                            zip,
                            lastName: lastName,
                            firstName: `${firstName} ${lastName}`,
                            country: "Brazil",
                            company: companyAd
                        }
                    ],
                    metafields: [
                        {
                            namespace: "custom",
                            key: "ie",
                            type: "single_line_text_field",
                            value: inscricaoEstadual
                        },
                        {
                            namespace: "custom",
                            key: "cnpj",
                            type: "single_line_text_field",
                            value: cnpjMatriz.replace(/\D/g, '')
                        },
                        {
                            namespace: "custom",
                            key: "bairro",
                            type: "single_line_text_field",
                            value: bairro
                        },
                        {
                            namespace: "custom",
                            key: "logradouro",
                            type: "single_line_text_field",
                            value: address1
                        },
                        {
                            namespace: "custom",
                            key: "numero",
                            type: "single_line_text_field",
                            value: `${numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField}`
                        },
                        {
                            namespace: "custom",
                            key: "nome_da_empresa",
                            type: "single_line_text_field",
                            value: companyAd
                        },
                        {
                            namespace: "custom",
                            key: "permissao_ativacao_marketing",
                            type: "boolean",
                            value: remarketing ? "true" : "false"
                        },
                        {
                            namespace: "custom",
                            key: "email_contact",
                            type: "single_line_text_field",
                            value: emailContact
                        },
                        {
                            namespace: "custom",
                            key: "phone_contact",
                            type: "single_line_text_field",
                            value: phone?.value?.length > 9 ? formatPhoneSend(phone) : ''
                        },
                        {
                            namespace: "custom",
                            key: "cargo",
                            type: "single_line_text_field",
                            value: cargo
                        }
                    ]
                }
            };

            fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    query,
                    variables
                })
            }).then(response => response.json())
                .then(data => {
                    if (!data) return;

                    if (data.errors) {
                        const errorStr = Object.entries(data.errors)
                            .map(([key, value]) => `${key}: ${value[0]}`)
                            .join(', ');

                        displayMessage(errorStr);
                    }

                    const customerId = userId;

                    if (customerId) {
                        console.log('Customer create...');
                        updateProgress(4);
                        console.log('Creating company...');

                        // createCompany(customerId, companyAd, firstName, lastName, address1, '', city, state, zip, 'BR')
                    }

                })
                .catch(error => console.error('Erro:', error));
        }
        else {
            const body = {
                customer: {
                    "first_name": firstName,
                    "last_name": lastName,
                    "email": email,
                    "phone": '',
                    "verified_email": true,
                    "email_marketing_consent": {
                        "state": "subscribed",
                        "opt_in_level": "single_opt_in",
                        "consent_updated_at": null
                    },
                    "addresses": [{
                        "address1": address1 + ", " + (numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField),
                        "address2": complemento ? `${complemento}, ${bairro}` : bairro,
                        "city": city,
                        "province": state,
                        "phone": phone?.value?.length > 9 ? formatPhoneSend(phone) : formatPhoneSend(phoneContact),
                        "zip": zip,
                        "last_name": lastName,
                        "first_name": firstName + ' ' + lastName,
                        "country": 'Brazil',
                        "company": companyAd
                    }],
                    "metafields": [
                        {
                            "namespace": "custom",
                            "key": "bairro",
                            "type": "single_line_text_field",
                            "value": bairro
                        },
                        {
                            "namespace": "custom",
                            "key": "logradouro",
                            "type": "single_line_text_field",
                            "value": address1
                        },
                        {
                            "namespace": "custom",
                            "key": "numero",
                            "type": "single_line_text_field",
                            "value": `${numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField}`
                        },
                        {
                            "namespace": "custom",
                            "key": "ie",
                            "type": "single_line_text_field",
                            "value": inscricaoEstadual
                        },
                        {
                            "namespace": "custom",
                            "key": "cnpj",
                            "value": cnpjMatriz.replace(/\D/g, ''),
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "nome_da_empresa",
                            "value": companyAd,
                            "type": "single_line_text_field"
                        },

                        {
                            "namespace": "custom",
                            "key": "permissao_ativacao_marketing",
                            "value": remarketing,
                            "type": "boolean"
                        },
                        {
                            "namespace": "custom",
                            "key": "email_contact",
                            "value": emailContact,
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "phone_contact",
                            "value": formatPhoneSend(phoneContact),
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "cargo",
                            "value": cargo,
                            "type": "single_line_text_field"
                        }
                    ]
                }
            };

            fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body)
            })
                .then(response => response.json())
                .then(data => {
                    if (!data) return;

                    if (data.errors) {
                        const errorStr = Object.entries(data.errors)
                            .map(([key, value]) => `${key}: ${value[0]}`)
                            .join(', ');

                        displayMessage(errorStr);
                    }

                    const customerId = data.customer.id;

                    if (customerId) {
                        console.log('Customer create...');
                        updateProgress(4);
                        console.log('Creating company...');

                        // createCompany(customerId, companyAd, firstName, lastName, address1, '', city, state, zip, 'BR')
                    }

                })
                .catch(error => console.error('Erro:', error));
        }

    });

});


